import { pickSessionPriorityViewWithIdSchema } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getWorkOrderPriorityFilters = {
  name: "getWorkOrderPriorityFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(pickSessionPriorityViewWithIdSchema) }),
};
